import { ExternalDerivationRepository } from "@beneficiary/data/repositories/external-derivation.repository";
import { CreateExternalDerivation } from "@beneficiary/domain/models/external-derivation/create-external-derivation.model";
import { ExternalDerivation } from "@beneficiary/domain/models/external-derivation/external-derivation.model";
import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { inject, injectable } from "inversify";

@injectable()
export class CreateExternalDerivationUseCase {
    constructor(
        @inject(ExternalDerivationRepository)
        private readonly externalDerivationRepository: ExternalDerivationRepository,
    ) {}

    async execute(
        externalDerivation: CreateExternalDerivation,
    ): Promise<Nullable<ExternalDerivation>> {
        const result =
            await this.externalDerivationRepository.create(externalDerivation);

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
        }

        return result.fold(
            () => null,
            (createdExternalDerivation) => createdExternalDerivation,
        );
    }
}
